import DatabaseModel from './DatabaseModel.js';

// Adapter del flujo "Incorporar documentación (IA)" del item enriquecido: sube el
// documento (multipart), y confirma/descarta la propuesta de la IA. El listado del
// dossier cuelga del item: GET /itemsenriquecidos/{id}/documentos.
var ItemDocumento = Object.create(DatabaseModel);

ItemDocumento.model = 'itemdocumento';
ItemDocumento.modelFront = 'itemdocumento';

/**
 * Sube el documento (copia propia del item) y lanza el análisis IA en segundo plano.
 * Multipart a mano (patrón Documento.upload): el navegador pone el boundary.
 *
 * @returns Promise<{lanzado, enCurso, idDocumento}>
 */
ItemDocumento.procesar = function(idItem, file, forzar) {
    var self = this;
    var data = new FormData();
    data.append('idItem', idItem);
    data.append('file', file);
    // forzar=true salta la deduplicación por hash (re-analizar un documento ya incorporado).
    data.append('forzar', forzar ? 'true' : 'false');
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/procesar',
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: data
        }).then(function({ data }) {
            if (data.error) { reject(data.error); } else { resolve(data.dto || data); }
        }).catch(function({ xhr }) {
            try { reject(JSON.parse(xhr.response).error); } catch (e) { reject(xhr && xhr.response); }
        });
    });
};

/**
 * Confirma la propuesta de la IA (crea el evento y actualiza el catálogo de tipos).
 *
 * Son dos peticiones distintas y el servidor las distingue por `aceptarTalCual`, que es
 * OBLIGATORIA en las dos:
 * - `true`: aplica la propuesta que tiene guardada y no admite ningún otro campo
 *   (usa `aceptarTalCual()`, que es la que la manda sola);
 * - `false`: es una corrección y `motivo` es obligatorio.
 *
 * Si no viaja, el servidor contesta que la pantalla está desactualizada y no confirma nada: es
 * como se reconoce una pestaña abierta antes del despliegue, en vez de darla por aceptación.
 */
ItemDocumento.confirmar = function(payload) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/confirmar',
        method: 'POST',
        data: payload || {}
    }, false).then(function(res) {
        return res && res.dto;
    });
};

/**
 * Acepta la propuesta tal cual: un clic y sin motivo. No se manda nada más que el documento,
 * porque lo que se aplica es la propuesta guardada en el servidor y cualquier otro campo haría
 * que la petición se rechazara por contradictoria.
 */
ItemDocumento.aceptarTalCual = function(idDocumento) {
    return this.confirmar({ idDocumento: idDocumento, aceptarTalCual: true });
};

/** Descarta la propuesta: borra el registro del dossier y el fichero copiado. Motivo obligatorio. */
ItemDocumento.descartar = function(idDocumento, motivo) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/descartar',
        method: 'POST',
        data: { idDocumento: idDocumento, motivo: motivo }
    }, false);
};

/**
 * Edita a mano los campos (valor/ámbito/añadir/quitar) de un evento. Devuelve el evento
 * actualizado. El motivo es obligatorio —volver a los campos es corregir lo que extrajo la IA— y
 * va en la query porque el cuerpo de este endpoint es la lista de campos.
 */
ItemDocumento.editarCamposEvento = function(idEvento, campos, motivo) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/evento/' + idEvento
            + '/campos?motivo=' + encodeURIComponent(motivo || ''),
        method: 'POST',
        data: campos || []
    }, false).then(function(res) {
        return res && res.dto;
    });
};

/** Elimina un evento documental/manual y su documento asociado. */
ItemDocumento.eliminarEvento = function(idEvento) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/evento/' + idEvento + '/eliminar',
        method: 'POST',
        data: {}
    }, false);
};

/** Elimina un documento; borrarEvento=true elimina también su evento asociado. */
ItemDocumento.eliminar = function(idDocumento, borrarEvento) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idDocumento + '/eliminar?borrarEvento=' + (borrarEvento ? 'true' : 'false'),
        method: 'POST',
        data: {}
    }, false);
};

/** Dossier documental del item, más reciente primero. */
ItemDocumento.deItem = function(idItem) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + 'itemsenriquecidos/' + idItem + '/documentos',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

/** Catálogo de tipos de evento (para el select de corrección de la propuesta). */
ItemDocumento.tiposEvento = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + 'itemevento/tipos',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

export default ItemDocumento;
